<template>
  <div>
    <div 
      v-if="loading"
      class="loading"
      v-loading="loading"
      element-loading-text="跳转中...">
    </div>
    <div class="content" v-else>
      <img src="../../assets/wangluo.jpg" alt="">
      <p>网络异常...  </p>
      <!-- <el-button>默认按钮</el-button> -->
     
    </div>
  </div>
</template>

<script>
import {prtcApply} from '@/api/intermediary.js'
export default {
  data(){
    return{
      loading:true
    }
  },
  created() {
    if(this.$route.query.outerOrderNo){
      prtcApply({outerOrderNo:this.$route.query.outerOrderNo}).then(res=>{
        if(res.data) window.location.href = res.data
      })
      .catch(e=>{
        if(e.data&&e.data.url){
          setTimeout(function(){
            window.location.href= e.data.url
          },4000)
        } else{
          this.loading = false
        }
        // http://localhost:8092/#/intermediary
      })
    }
    
  },
 
}
</script>

<style lang='scss' scoped>
 .loading{
   width: 100vw;
   height: 100vh;
 }
 .content{
    width: 100vw;
    height: 100vh;
    background-color: #f6f6f6;
    overflow: hidden;
    img{
     display: block;
     margin: auto;
     margin-top: 60px;
    } 
    p{
      text-align: center;
      font-size: 34px;
      font-weight: 700;
    }
    // .el-button{
    //   margin: auto;
    //   display: block;
    //   margin-top: 30px;
    // }
 }
</style>